import React from 'react';
import WName from '../WName';
import QL from './QuestionLink';
import PL from '../problems/ProblemLink';
import AL from '../angles/AngleLink';
import NW from '../neologisms/NewWord';
import OML from '../ormaybe/OrMaybeLink';
import LRL from '../longreads/LongReadLink';
import {E1, E2, Qual} from '../common';

// ‘’

// What is an 'other'?
export const other = {
  name: "other",
  alternatives: "others",
  question: <span>What is an ‘Other<sup>™</sup>’</span>,
  clarification: <span>And why does it get <i>quotes</i>… and sometimes a blithering ™?</span>,
  answerPreview: <div className="answer-preview">
    <p>The <PL>human-standard</PL> perception of <LRL>reality</LRL> as divided into ‘<PL name="individuality">Self</PL><sup>™</sup>’ v. ‘Others<sup>™</sup>’ is a <LRL>symptom</LRL> of our conscious <NW>polygnosticity</NW> – and inability to directly (and <i>easily</i>) <LRL name="communism">share thoughts</LRL>. The insistence that we will <i>always</i> be thus devided is an appeal to <PL>metaphysics</PL> instead of <AL name="fields.logic">reason</AL>, and <NW>conservative thinking</NW> (with maybe a ‘helping’ of <NW>Einzelgier</NW> on the side).</p>
[under construction]
  </div>,
//  answer: <div className="answer">
//  </div>,
};
